import { connect } from 'react-redux';

import RedirectToLKIP from '../components/RedirectToLKIP';
import { getLkIp } from '../redux/lkIp/actions';

@connect(function ({ app: { lkIp } }) {
  return {
    lkIp,
  };
})
export default class RedirectToLKIPContainer extends RedirectToLKIP {
  componentDidMount() {
    this.getLkIp();
  }

  getLkIp() {
    this.props.dispatch(getLkIp());
  }
}
